module.exports = __webpack_public_path__ + "media/images/road_sign-519201b65e3d4cfa2e1605912ae73760.png";